export default __webpack_public_path__ + "static/media/linkedInIcon.e40c144c.svg";